// Ephemeral image attachments: converted to base64 data URLs client-side and
// sent along with the turn's request. Never uploaded or stored anywhere — the
// data URL only exists in memory for the life of that one message.
export type Attachment = { name?: string; contentType?: string; url: string };

const MAX_BYTES = 8 * 1024 * 1024; // 8MB raw file size

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

export function readImageAsAttachment(file: File): Promise<Attachment> {
  return new Promise((resolve, reject) => {
    if (!isImageFile(file)) {
      reject(new Error(`${file.name || 'file'} isn't an image`));
      return;
    }
    if (file.size > MAX_BYTES) {
      reject(new Error(`${file.name || 'image'} is too large (max 8MB)`));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve({ name: file.name, contentType: file.type, url: String(reader.result) });
    reader.onerror = () => reject(reader.error ?? new Error('failed to read file'));
    reader.readAsDataURL(file);
  });
}
